import React from "react";

const TableRow = ({ value, className }) => (
  <th
    className={`py-3 px-1 text-[13px] font-normal text-left break-all ${className}`}
  >
    {value}
  </th>
);

export default TableRow;
